import { Flex, GridAlpha, Notice, Text } from '@applyboard/crystal-ui';
import { CardProps } from '../ServiceCard';
import { default as RpServiceCard } from '../ServiceCard/RpServiceCard';
import { default as StudentServiceCard } from '../ServiceCard/StudentServiceCard';

type Persona = 'student' | 'rp';

const renderServiceCards = (cardsData: CardProps[], persona: Persona) =>
  cardsData.map(cardData => {
    if (persona === 'rp') {
      const ServiceCardType = cardData.serviceCardType || RpServiceCard;
      return (
        <ServiceCardType
          key={cardData.cardKey}
          cardKey={cardData.cardKey}
          service={cardData.service}
          serviceLabel={cardData.serviceLabel}
          vendor={cardData.vendor}
          badge={cardData.badge}
          image={cardData.image}
          isImageForAvatar={cardData.isImageForAvatar}
          title={cardData.title}
          isTitleUnderImage={cardData.isTitleUnderImage}
          description={cardData.description}
          shareLinkButtonName={cardData.shareLinkButtonName}
          marketingTemplateLink={cardData.marketingTemplateLink}
          applyButtonName={cardData.applyButtonName}
          applyButtonCTAUrl={cardData.applyButtonCTAUrl}
          vendorUrl={cardData.vendorUrl}
          disabled={cardData.disabled}
          tooltip={cardData.tooltip}
          pricing={cardData.pricing}
          isSoldOut={cardData.isSoldOut}
          isLoadingPrice={cardData.isLoadingPrice}
          priceError={cardData.priceError}
        />
      );
    } else {
      const ServiceCardType = cardData.serviceCardType || StudentServiceCard;
      return (
        <ServiceCardType
          key={cardData.cardKey}
          cardKey={cardData.cardKey}
          badge={cardData.badge}
          image={cardData.image}
          isImageForAvatar={cardData.isImageForAvatar}
          title={cardData.title}
          isTitleUnderImage={cardData.isTitleUnderImage}
          description={cardData.description}
          shareLinkButtonName={cardData.shareLinkButtonName}
          applyButtonName={cardData.applyButtonName}
          applyButtonCTAUrl={cardData.applyButtonCTAUrl}
          vendorUrl={cardData.vendorUrl}
          disabled={cardData.disabled}
          service={cardData.service}
          serviceLabel={cardData.serviceLabel}
          vendor={cardData.vendor}
          pricing={cardData.pricing}
          isSoldOut={cardData.isSoldOut}
          isLoadingPrice={cardData.isLoadingPrice}
          priceError={cardData.priceError}
        />
      );
    }
  });

const NoResultsMessage = () => (
  <Flex align="center" justify="center" grow={1} py={4} direction="column" gap={2}>
    <Text variant="headlineS" intent="secondary">
      No services available for the selected filters
    </Text>
    <Text variant="bodyS" intent="secondary">
      Try adjusting your nationality or destination filters to see more options.
    </Text>
  </Flex>
);

export const ServiceCardsDisplay = ({
  cardsData,
  persona,
  showUsdNotice = false,
}: {
  cardsData: CardProps[];
  persona: Persona;
  showUsdNotice?: boolean;
}) => {
  if (!cardsData.length) {
    return <NoResultsMessage />;
  }

  return (
    <Flex justify="center">
      <GridAlpha
        columns={{
          sm: 'repeat(1, 1fr)',
          md: 'repeat(auto-fill, minmax(380px, 1fr))',
        }}
        columnGap={4}
        rowGap={6}
      >
        {showUsdNotice && (
          <GridAlpha.Item
            columnStart={{ xs: 1, sm: 1, md: 1 }}
            columnEnd={{ xs: -1, sm: -1, md: -1 }}
          >
            <Notice intent="primary" width="fill">
              <b>Prices are displayed in USD.</b> During checkout you can pay in your local currency
              using local payment options.
              <br />
              You must charge applicable taxes to the end customer. Voucher purchases may be subject
              to Reverse Charge procedures based on your local government&apos;s law.
            </Notice>
          </GridAlpha.Item>
        )}
        {cardsData.map(card => (
          <GridAlpha.Item key={card.cardKey}>{renderServiceCards([card], persona)}</GridAlpha.Item>
        ))}
      </GridAlpha>
    </Flex>
  );
};
